<!-- BASIC VERSION -> TODO -->
<div class="flex justify-center">
    @if (routeData$ | async; as data) {
        <p>{{ data?.statusCode }}</p>
        <br />
        <p>{{ data?.message }}</p>
    }
</div>
